import Utilities from "../_utilities";
/* リードコンテンツ用スクロール制御 */
export default class LeadingScrollCtl {
    // ppos: number; //検証用
    constructor() {
        this.html = document.documentElement;
        this.currentWindowWidth = window.innerWidth;
        this.currentWindowHeight = window.innerHeight;
        this.isHorizontal = false;
        // footer制御用
        this.footerWrapper = document.getElementById('mainfooter');
        this.footer = document.querySelector('.l-mainfooter');
        this.footerWidth = this.footerWrapper.getBoundingClientRect().width;
        this.footerHeight = this.footerWrapper.getBoundingClientRect().height;
        this.footerTriggerPoint = this.footerWrapper.getBoundingClientRect().top + window.scrollY;
        this.footerTriggerPointHorizontal = this.footerWrapper.getBoundingClientRect().left + window.scrollX;
        // this.ppos = window.scrollX; //検証用
        window.addEventListener('resize', (ev) => {
            this.resizeUpdate();
        });
        this.resizeUpdate();
        // footer位置初期化
        setTimeout(() => {
            if (!Utilities.isTouchDevice() && !this.isHorizontal) {
                this.footer.style.transform = 'translateY(' + (this.footerHeight * -0.5) + 'px) translateX(0)';
            }
            else if (!Utilities.isTouchDevice() && this.isHorizontal) {
                this.footer.style.transform = 'translateX(' + (this.footerWidth * -0.5) + 'px) translateY(0)';
            }
        }, 300);
    }
    static getInstance() {
        if (!this.lenis) {
            this.lenis = new LeadingScrollCtl;
            this.lenis.activate();
        }
        return this.lenis;
    }
    // リサイズ時情報更新
    resizeUpdate() {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
            // ウィンドウサイズ情報更新
            this.currentWindowWidth = window.innerWidth;
            this.currentWindowHeight = window.innerHeight;
            if (this.currentWindowWidth >= 1280 && this.currentWindowHeight >= 800) {
                this.isHorizontal = true;
                this.html.classList.add('is-horizontal');
                // タッチデバイス（viewport縮小）対応
                if (Utilities.isTouchDevice()) {
                    this.html.classList.add('is-horizontal-touch');
                }
                else {
                    this.html.classList.remove('is-horizontal-touch');
                }
            }
            else {
                this.isHorizontal = false;
                this.html.classList.remove('is-horizontal');
                this.html.classList.remove('is-horizontal-touch');
            }
            // フッター座標情報更新
            this.footerWidth = this.footerWrapper.getBoundingClientRect().width;
            this.footerHeight = this.footerWrapper.getBoundingClientRect().height;
            this.footerTriggerPoint = this.footerWrapper.getBoundingClientRect().top + window.scrollY;
            this.footerTriggerPointHorizontal = this.footerWrapper.getBoundingClientRect().left + window.scrollX;
            this.lenisObj.resize(); // 最大スクロール量を再計算
        }, 200);
    }
    activate() {
        const _this = this;
        _this.lenisObj = new Lenis({ orientation: 'vertical' });
        function raf(time) {
            _this.lenisObj.raf(time);
            // スクロール縦横処理
            if (_this.isHorizontal) {
                _this.lenisObj.options.orientation = 'horizontal';
            }
            else {
                _this.lenisObj.options.orientation = 'vertical';
            }
            // スクロール進行方向処理
            if (_this.lenisObj.direction > 0) {
                // 下スクロール中
                _this.html.classList.add('is-scrolldown');
                _this.html.classList.remove('is-scrollup');
            }
            else if (_this.lenisObj.direction < 0) {
                // 上スクロール中
                _this.html.classList.add('is-scrollup');
                _this.html.classList.remove('is-scrolldown');
            }
            // コンテンツ上部かどうか
            if (_this.lenisObj.scroll > 180) {
                _this.html.classList.add('is-belowhead');
                _this.html.classList.remove('is-abovehead');
            }
            else {
                _this.html.classList.add('is-abovehead');
                _this.html.classList.remove('is-belowhead');
            }
            // footer制御用
            // フッター位置更新
            _this.footerTriggerPoint = _this.footerWrapper.getBoundingClientRect().top + window.scrollY;
            _this.footerTriggerPointHorizontal = _this.footerWrapper.getBoundingClientRect().left + window.scrollX;
            if (!Utilities.isTouchDevice() && !_this.isHorizontal) {
                if (_this.lenisObj.scroll + window.innerHeight >= _this.footerTriggerPoint) {
                    const footerPos = Math.min(0, (Math.floor((_this.footerHeight * -0.5) + ((_this.lenisObj.scroll + window.innerHeight) - _this.footerTriggerPoint) * 0.5) + 1));
                    _this.footer.style.transform = 'translateY(' + footerPos + 'px) translateX(0)';
                }
            }
            else if (!Utilities.isTouchDevice() && _this.isHorizontal) {
                if (_this.lenisObj.scroll + window.innerWidth >= _this.footerTriggerPointHorizontal) {
                    const footerPos = Math.min(0, (Math.floor((_this.footerWidth * -0.5) + ((_this.lenisObj.scroll + window.innerWidth) - _this.footerTriggerPointHorizontal) * 0.5) + 1));
                    _this.footer.style.transform = 'translateX(' + footerPos + 'px) translateY(0)';
                }
            }
            else {
                _this.footer.style.transform = 'translateX(0) translateY(0)';
            }
            // スクロール検証用
            // if( _this.ppos !== _this.lenisObj.scroll ){
            // 	_this.ppos = _this.lenisObj.scroll;
            // 	//console.log(_this.ppos)
            // }
            requestAnimationFrame(raf);
        }
        // タッチデバイスの場合は慣性スクロール非アクティブ
        requestAnimationFrame(raf);
    }
    // スクロールロック時に解除
    lock() {
        this.lenisObj.stop();
    }
    // スクロールロック解除時にアクティブ
    unlock() {
        this.lenisObj.start();
    }
}
